export default __webpack_public_path__ + "static/10.03-2-b74a4a1a0cb450ba0ea37edb8e850541.png";